import PlayerPositionCategory from "./player-position-category";

const PlayerPosition = Object.freeze({
    OFFENSIVE_LINE: {
        name: "Offensive Line",
        code: "OL",
        category: PlayerPositionCategory.OFFENSE
    },
    TACKLE: {
        name: "Tackle",
        code: "T",
        category: PlayerPositionCategory.DEFENSE
    },
    LEFT_TACKLE: {
        name: "Left Tackle",
        code: "LT",
        category: PlayerPositionCategory.DEFENSE
    },
    RIGHT_TACKLE: {
        name: "Right Tackle",
        code: "RT",
        category: PlayerPositionCategory.DEFENSE
    },
    NOSE_TACKLE: {
        name: "Nose Tackle",
        code: "NT",
        category: PlayerPositionCategory.DEFENSE
    },
    GUARD: {
        name: "Guard",
        code: "G",
        category: PlayerPositionCategory.OFFENSE
    },
    LEFT_GUARD: {
        name: "Left Guard",
        code: "LG",
        category: PlayerPositionCategory.OFFENSE
    },
    RIGHT_GUARD: {
        name: "Right Guard",
        code: "RG",
        category: PlayerPositionCategory.OFFENSE
    },
    OFFENSIVE_GUARD: {
        name: "Offensive Guard",
        code: "OG",
        category: PlayerPositionCategory.OFFENSE
    },
    OFFENSIVE_TACKLE: {
        name: "Offensive Tackle",
        code: "OT",
        category: PlayerPositionCategory.OFFENSE
    },
    CENTER: {
        name: "Center",
        code: "C",
        category: PlayerPositionCategory.OFFENSE
    },
    QUARTERBACK: {
        name: "Quarterback",
        code: "QB",
        category: PlayerPositionCategory.PASSING
    },
    RUNNING_BACK: {
        name: "Running Back",
        code: "RB",
        category: PlayerPositionCategory.RUSHING
    },
    HALFBACK: {
        name: "Halfback",
        code: "HB",
        category: PlayerPositionCategory.RUSHING
    },
    FULLBACK: {
        name: "Fullback",
        code: "FB",
        category: PlayerPositionCategory.RUSHING
    },
    TAILBACK: {
        name: "Tailback",
        code: "TB",
        category: PlayerPositionCategory.RUSHING
    },
    SLOT_BACK: {
        name: "Slot Back",
        code: "SB",
        category: PlayerPositionCategory.RUSHING
    },
    TIGHT_END: {
        name: "Tight End",
        code: "TE",
        category: PlayerPositionCategory.RECEIVING
    },
    WIDE_RECEIVER: {
        name: "Wide Receiver",
        code: "WR",
        category: PlayerPositionCategory.RECEIVING
    },
    DEFENSIVE_END: {
        name: "Defensive End",
        code: "DE",
        category: PlayerPositionCategory.DEFENSE
    },
    DEFENSIVE_TACKLE: {
        name: "Defensive Tackle",
        code: "DT",
        category: PlayerPositionCategory.DEFENSE
    },
    DEFENSIVE_LINE: {
        name: "Defensive Line",
        code: "DL",
        category: PlayerPositionCategory.DEFENSE
    },
    DEFENSIVE_GUARD: {
        name: "Defensive Guard",
        code: "DG",
        category: PlayerPositionCategory.DEFENSE
    },
    OUTSIDE_LINEBACKER: {
        name: "Outside Linebacker",
        code: "OLB",
        category: PlayerPositionCategory.DEFENSE
    },
    RIGHT_OUTSIDE_LINEBACKER: {
        name: "Right Outside Linebacker",
        code: "ROLB",
        category: PlayerPositionCategory.DEFENSE
    },
    LEFT_OUTSIDE_LINEBACKER: {
        name: "Left Outside Linebacker",
        code: "LOLB",
        category: PlayerPositionCategory.DEFENSE
    },
    INSIDE_LINEBACKER: {
        name: "Inside Linebacker",
        code: "ILB",
        category: PlayerPositionCategory.DEFENSE
    },
    LINEBACKER: {
        name: "Linebacker",
        code: "LB",
        category: PlayerPositionCategory.DEFENSE
    },
    MIDDLE_LINEBACKER: {
        name: "Middle Linebacker",
        code: "MLB",
        category: PlayerPositionCategory.DEFENSE
    },
    CORNER_BACK: {
        name: "Corner Back",
        code: "CB",
        category: PlayerPositionCategory.DEFENSE
    },
    SAFETY: {
        name: "Safety",
        code: "S",
        category: PlayerPositionCategory.DEFENSE
    },
    FREE_SAFETY: {
        name: "Free Safety",
        code: "FS",
        category: PlayerPositionCategory.DEFENSE
    },
    STRONG_SAFETY: {
        name: "Strong Safety",
        code: "SS",
        category: PlayerPositionCategory.DEFENSE
    },
    DEFENSIVE_BACK: {
        name: "Defensive Back",
        code: "DB",
        category: PlayerPositionCategory.DEFENSE
    },
    KICKER: {
        name: "Kicker",
        code: "K",
        category: PlayerPositionCategory.KICKING
    },
    KICK_RETURNER: {
        name: "Kick Returner",
        code: "KR",
        category: PlayerPositionCategory.KICKING
    },
    PUNTER: {
        name: "Punter",
        code: "P",
        category: PlayerPositionCategory.PUNTING
    },
    PUNT_RETURNER: {
        name: "Punt Returner",
        code: "PR",
        category: PlayerPositionCategory.PUNTING
    },
    LONG_SNAPPER: {
        name: "Long Snapper",
        code: "LS",
        category: PlayerPositionCategory.DEFENSE
    }
});

export const fromCode = (code) => {
    return Object.values(PlayerPosition).filter((pp) => pp.code === code)[0];
};

export default PlayerPosition;
